import { ADMIN_ACCESS, EVERY_PERMISSION, PROPERTY_MANAGER_ACCESS } from "@shyne/shared";
import type { MembershipRole } from "@shyne/shared/api";

const PERMISSIONS_OF_ROLE: Record<MembershipRole, readonly string[]> = {
  admin: ADMIN_ACCESS,
  propertyManager: PROPERTY_MANAGER_ACCESS,
  member: [],
};

export const permissionsOf = (role: MembershipRole): readonly string[] => PERMISSIONS_OF_ROLE[role];

export const grants = (permissions: readonly string[], permission: string): boolean => permissions.includes(EVERY_PERMISSION) || permissions.includes(permission);
